import React, { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { RELEASES } from "../data/releaseNotes";
import "./ReleaseNotesModal.css";

/**
 * 새 소식. 큰 기능만 달별로 모아 둔다.
 *
 * 새 기능 안내(FeatureNoticeModal)는 한 번 뜨고 사라진다. 나중에 다시 찾을
 * 곳이 필요했다. body 에 붙인다 — 조상에 transform 이 남으면 fixed 가 화면
 * 대신 그 조상을 기준으로 잡는다.
 */
export default function ReleaseNotesModal({ onClose, onGo }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const months = useMemo(() => {
    const m = new Map();
    for (const r of RELEASES) {
      const k = r.date.slice(0, 7);
      if (!m.has(k)) m.set(k, []);
      m.get(k).push(r);
    }
    return [...m];
  }, []);

  return createPortal(
    <div className="rn-overlay" onClick={onClose}>
      <div className="rn-modal" role="dialog" aria-modal="true" aria-labelledby="rn-title"
        onClick={(e) => e.stopPropagation()}>
        <div className="rn-head">
          <h2 id="rn-title" className="rn-title"><span className="rn-star" aria-hidden="true">✦</span> 새 소식</h2>
          <button className="rn-x" onClick={onClose} aria-label="닫기">✕</button>
        </div>
        <p className="rn-lead">MUROO 에 새로 생긴 큰 기능을 모아 뒀어요</p>

        {months.map(([ym, items]) => (
          <section key={ym} className="rn-month">
            <div className="rn-ym"><b>{Number(ym.slice(0, 4))}</b>년 <b>{Number(ym.slice(5))}</b>월</div>
            {items.map((r) => (
              <article key={r.id} className="rn-item">
                <div className="rn-day"><b>{Number(r.date.slice(8))}</b>일</div>
                <div className="rn-main">
                  <div className="rn-t"><span className="rn-ic" aria-hidden="true">{r.icon}</span>{r.title}</div>
                  <p className="rn-d">{r.body}</p>
                  {r.go && onGo && (
                    <button className="rn-go" onClick={() => onGo(r.go)}>써보기 →</button>
                  )}
                </div>
              </article>
            ))}
          </section>
        ))}
      </div>
    </div>,
    document.body
  );
}
